<template>
  <div :class="['blue-button', widthClass]" class="position-relative">
    <b-button
      :disabled="disabled || loading"
      @click.stop="$emit('clicked'), $event.target.blur()"
      class="rounded-pill d-flex align-items-center justify-content-center"
      :style="styles"
    >
      <img v-show="src !== null" :src="src" alt="" />
      <span :class="{ 'opacity-0': loading }">
        {{ text }}
      </span>
      <div class="loader-pos" v-show="loading">
        <Loader />
      </div>
    </b-button>
  </div>
</template>

<script>
export default {
  name: "PrimaryButton",

  props: {
    styles: {
      type: Object,
      default: () => ({}),
    },
    text: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    widthClass: {
      type: String,
      default: "button-fit-content",
    },
  },
};
</script>

<style scoped>
.download-btn button {
  height: 33.5px;
  display: flex;
  align-items: center !important;
  justify-content: center !important;
}
.loader-pos {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.blue-button .spinner-border {
  height: 1.563rem;
  width: 1.563rem;
  margin-top: 0.188rem;
  border: 0.25em solid var(--color-white);
  border-right-color: transparent;
}

.blue-button .btn-secondary {
  background-color: var(--primary-blue);
  border: 1px solid var(--primary-blue);
  color: var(--color-white);
  padding: 0.25rem 1.125rem;
  font-family: "Montserrat", sans-serif;
  font-size: var(--size-13);
  font-weight: var(--weight-M);
  display: flex;
  align-items: normal;
  justify-content: center;
  gap: 0.625rem;
  width: 100%;
}
.blue-button .btn-secondary.disabled,
.btn-secondary:disabled {
  opacity: 0.65;
}

.blue-button .btn-secondary:hover {
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}

.blue-button .btn-secondary:focus {
  border: 1px solid var(--primary-blue);
  color: var(--color-white);
  box-shadow: none;
}

.blue-button .btn-secondary:disabled {
  box-shadow: none;
}

.blue-button .btn-secondary:focus {
  border: 1px solid var(--primary-blue);
  color: var(--color-white);
  box-shadow: none;
}

.blue-button .btn-secondary:not(:disabled):not(.disabled):active,
.blue-button .btn-secondary:not(:disabled):not(.disabled).active,
.blue-button .show > .btn-secondary.dropdown-toggle {
  color: var(--color-white);
  background-color: var(--primary-blue);
  border-color: var(--primary-blue);
  box-shadow: none;
}
.button-width {
  width: 5.625rem;
}
.w-100px .btn-secondary {
  width: 100px !important;
}
.w-95px .btn-secondary {
  width: 95px !important;
}

.button-fit-content {
  width: fit-content;
}
.purchase-btn button {
  width: 100% !important;
  height: 42px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.certificate-btn button {
  width: 50% !important;
  height: 42px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
@media (max-width: 576px) {
  .purchase-btn button {
    height: 42px !important;
  }
}
.addbtn-w-100 button {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.w-200px button{
  width: 275px !important;
  height: 40px;
}
</style>
